module.exports = __webpack_public_path__ + "img/2005_S.df71a87f.png";